<div class="page-title">
    <h1>{{ title }}</h1>
    @if (imgSrc) {
        <img src="{{ imgSrc }}" alt="{{ title }}" />
    }
</div>
